module.exports = __webpack_public_path__ + "static/familia-local-shops-mobile-5e79f6f6adbd396ee92cf679be637b7e.png";